<template>
  <div class="land-home-purchase">
    <div class="home-purchase-title">即刻开始，开启您企业的数字新成本之旅</div>
    <div class="home-purchase-text">数字新成本，助力企业达成精细化成本管理</div>
    <div class="home-partner-btn">
      <el-button @click="purchase()" class="submitBtn">购买咨询</el-button>
    </div>
    <el-dialog
      width="404px"
      class="purchase-dialog"
      title="购买咨询"
      @close="resetFormClosed"
      :visible.sync="dialogFormVisible">
      <el-form
        :model="purchaseForm"
        label-position="top"
        :rules="purchaseRules"
        ref="purchaseRuleForm">
        <el-form-item
          label="所在地区"
          prop="region">
          <el-cascader
            v-model="purchaseForm.region"
            :options="options"
            clearable
            ref="cascaderItem"
            placeholder="请选择所在地区"
            :props="{ expandTrigger: 'hover' }"></el-cascader>
        </el-form-item>
        <el-form-item
          label="您的姓名"
          prop="name">
          <el-input
            v-model.trim="purchaseForm.name"
            placeholder="请输入您的姓名"
            maxlength="20"
            autocomplete="off"
            clearable></el-input>
        </el-form-item>
        <el-form-item
          label="联系手机"
          prop="phone">
          <el-input
            v-model.trim="purchaseForm.phone"
            maxlength="11"
            placeholder="请输入联系手机"
            autocomplete="off"
            clearable></el-input>
        </el-form-item>
        <el-form-item
          label="单位名称"
          prop="company">
          <el-input
            v-model="purchaseForm.company"
            placeholder="请输入单位名称"
            maxlength="250"
            autocomplete="off"
            clearable></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <el-button
          type="primary"
          @click="consultationSubmit"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cityMap from '../../../../../../locales/cityMap.json'
import { addConsult } from '@/api/landing'
/* 校验电话码格式 */
const isTelCode = (rule, value, callback) => {
  const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
  if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

export default {
  name: 'landHomePurchase',
  data () {
    return {
      dialogFormVisible: false,
      options: cityMap,
      purchaseForm: {
        name: '',
        region: '',
        phone: '',
        company: ''
      },
      purchaseRules: {
        name: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        region: [
          { type: 'array', required: true, message: '请选择地区', trigger: 'blur' },
          { type: 'array', required: true, message: '请选择地区', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { validator: isTelCode, trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 添加
    handleAdd () {
      this.dialogFormVisible = true
    },
    // 关闭
    handleClose () {
      this.dialogFormVisible = false
    },
    // 购买咨询表单提交
    consultationSubmit () {
      this.$refs.purchaseRuleForm.validate((valid) => {
        if (valid) {
          this.purchaseForm.region = this.$refs.cascaderItem.inputValue
          addConsult(this.purchaseForm).then(res => {
            const { code, data, message } = res
            if (code === 200) {
              if (data) {
                this.$message.success('提交成功!')
              }
            } else {
              message && this.$message.error(message)
            }
          }).catch(() => {
          })
          this.sentLog(100102011)
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    // 清空表单
    resetFormClosed () {
      this.$refs.purchaseRuleForm.resetFields()
    },
    // 打开表单
    purchase () {
      this.dialogFormVisible = true
      this.sentLog(100102010)
    }
  }
}
</script>

<style lang="scss" scoped>
.land-home-purchase {
  width: 100%;
  height: 204px;
  margin: auto;
  background: url("../../../../../../assets/images/land-page/land-home/consultation2.jpg")
    no-repeat;
  padding-top: 42px;
  background-size: cover;
  .home-purchase-title {
    height: 50px;
    font-size: 36px;
    font-weight: 600;
    color: #fff;
    line-height: 50px;
    text-align: center;
  }
  .home-purchase-text {
    height: 32px;
    font-size: 20px;
    margin-top: 10px;
    margin-bottom: 26px;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
  }
  .home-partner-btn {
    margin: auto;
    text-align: center;
    ::v-deep .el-button--small {
      width: 142px;
      height: 43px;
      border-radius: 4px;
      border: 1px solid #fff;
      background: 0;
      font-size: 18px;
      font-weight: 400;
      color: #fff;
    }
    .submitBtn:hover{
      color: #4499ff;
      background-color: #fff;
    }
  }
}
.purchase-dialog {
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  ::v-deep .el-dialog__header {
    background: #49f;
    height: 32px;
    padding: 0 0 0 12px;
    .el-dialog__title {
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 32px;
    }
    .el-dialog__headerbtn {
      top: 10px;
      right: 12px;
    }
    .el-dialog__close {
      color: #fff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 19px 25px 0 25px;
  }
  ::v-deep .el-cascader--small {
    width: 100%;
  }
  ::v-deep .el-form-item__label {
    padding: 0;
  }
  ::v-deep .el-form-item__label:before {
    content: "" !important;
  }
  ::v-deep .el-form-item__label::after {
    position: inherit;
    content: "*";
    margin-left: 3px;
    width: 8px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #f00;
    line-height: 20px;
    right: 0;
    top: 0;
  }
  ::v-deep .el-button--small {
    width: 354px;
    height: 40px;
    border-radius: 4px;
    background: #49f;
    margin-left: 0 !important;
  }
  ::v-deep .el-dialog__footer {
    padding: 12px 24px 12px;
    height: 83px;
    border-top: 0 solid #d9d9d9;
  }
}
</style>
